import * as Blockly from 'blockly/core';
import 'blockly/javascript';

Blockly.JavaScript = {};